import { Anchor, Form, Progress } from "antd";
import React, { useEffect, useRef, useState } from "react";
import MultiSelectCheckboxGroup from "./MultiSelectCheckboxGroup";
import AddNewMarketModal from "../components/modalForms/Partner/AddNewMarketModel";
import SingleSelectButtonGroup from "./SingleSelectButtonGroup";

import { FormInstance } from "antd/es/form";
import { GetRegionsList } from "../../API/endpoints/Regions";
import {
  beautyOptions,
  channelOptions,
  functionalFoodBeveragesOptions,
  healthOptions,
  keyCapabilitiesOptions,
  petNutritionOptions,
  tabOptions,
  warehousingOptions,
} from "../../constants/dataConstants";

interface Props {
  containerRef: any;

  serviceScopeForm: FormInstance;

  serviceScopeData: {
    selectedHealthOptions: string[];
    setSelectedHealthOptions: (options: string[]) => void;
    selectedBeautyOptions: string[];
    setSelectedBeautyOptions: (options: string[]) => void;
    selectedChannelCoverage: string[];
    setSelectedChannelCoverage: (options: string[]) => void;
    selectedFoodBeverage: string[];
    setSelectedFoodBeverage: (options: string[]) => void;
    selectedPetNutrition: string[];
    setSelectedPetNutrition: (options: string[]) => void;
    selectedKeyCapabilities: string[];
    setSelectedKeyCapabilities: (options: string[]) => void;
    selectedWarehousing: string[];
    setSelectedWarehousing: (options: string[]) => void;
    selectedBusinessModels: string;
    setSelectedBusinessModels: (value: string) => void;
    selectedTradingTerms: string;
    setSelectedTradingTerms: (value: string) => void;
    selectedMarketingInvestment: string;
    setSelectedMarketingInvestment: (value: string) => void;
    selectedPaymentTerms: string;
    setSelectedPaymentTerms: (value: string) => void;
    otherValues: any;
    setOtherValues: any;
  };

  partnerDetails: any;
  setPartnerDetails: any;

  editPartnerData: any;
}

const ServiceAndScope = (props: Props) => {
  const {
    containerRef,
    serviceScopeForm,
    partnerDetails,
    setPartnerDetails,
    editPartnerData,
    serviceScopeData,
  } = props;

  const {
    selectedHealthOptions,
    setSelectedHealthOptions,
    selectedBeautyOptions,
    setSelectedBeautyOptions,
    selectedChannelCoverage,
    setSelectedChannelCoverage,
    selectedFoodBeverage,
    setSelectedFoodBeverage,
    selectedPetNutrition,
    setSelectedPetNutrition,
    selectedKeyCapabilities,
    setSelectedKeyCapabilities,
    selectedWarehousing,
    setSelectedWarehousing,
    selectedBusinessModels,
    setSelectedBusinessModels,
    selectedTradingTerms,
    setSelectedTradingTerms,
    selectedMarketingInvestment,
    setSelectedMarketingInvestment,
    selectedPaymentTerms,
    setSelectedPaymentTerms,
    otherValues,
    setOtherValues,
  } = serviceScopeData;

  const [openAddNewMarketModal, setOpenAddNewMarketModal] = useState(false);

  const [healthChecked, setHealthChecked] = useState(true);
  const [healthOtherValue, setHealthOtherValue] = useState("");
  const [beautyChecked, setBeautyChecked] = useState(true);
  const [beautyOtherValue, setBeautyOtherValue] = useState("");
  const [channelChecked, setChannelChecked] = useState(true);
  const [channelOtherValue, setChannelOtherValue] = useState("");
  const [selectedMarket, setSelectedMarket] = useState(
    partnerDetails.marketSelection[0] || {}
  );

  const [foodBeverageChecked, setFoodBeverageChecked] = useState(false);
  const [foodBeverageOtherValue, setFoodBeverageOtherValue] = useState("");

  const [petNutritionChecked, setPetNutritionChecked] = useState(false);
  const [petNutritionOtherValue, setPetNutritionOtherValue] = useState("");

  const [keyCapabilitiesChecked, setKeyCapabilitiesChecked] = useState(true);
  const [keyCapabilitiesOtherValue, setKeyCapabilitiesOtherValue] =
    useState("");

  const [warehousingChecked, setWarehousingChecked] = useState(true);
  const [warehousingOtherValue, setWarehousingOtherValue] = useState("");

  const [businessModelsChecked, setBusinessModelsChecked] = useState(true);

  const [tradingTermsChecked, setTradingTermsChecked] = useState(true);

  const [selectedMinTenure, setSelectedMinTenure] = useState("");
  const [minTenureChecked, setMinTenureChecked] = useState(true);

  const [marketingInvestmentChecked, setMarketingInvestmentChecked] =
    useState(true);

  const [paymentTermsChecked, setPaymentTermsChecked] = useState(true);
  const [marketProgressMap, setMarketProgressMap] = useState<
    Record<string, number>
  >({});

  const refHealthOptions = useRef<string[]>([]);
  const refBeautyOptions = useRef<string[]>([]);
  const refFoodOptions = useRef<string[]>([]);
  const refPetOptions = useRef<string[]>([]);
  const refChannel = useRef<string[]>([]);
  const refCapabilities = useRef<string[]>([]);
  const refWarehousing = useRef<string[]>([]);
  const refModel = useRef<string>("");
  const refTerms = useRef<string>("");
  const refTenure = useRef<string>("");
  const refMarketing = useRef<string>("");
  const refPayment = useRef<string>("");

  const [marketList, setMarketList] = useState([]);

  const getCategoryWithOther = (
    selected: string[],
    other: string
  ): string[] => {
    return other?.trim() ? [...selected, other.trim()] : selected;
  };

  const resolveOther = (selected: string[], category: string) => {
    return selected.map((item) =>
      item === "Other" ? getOtherValue(category) || item : item
    );
  };

  useEffect(() => {
    if (!selectedMarket?.name) return;

    const current = partnerDetails?.markets?.[selectedMarket.name];
    if (!current) return;

    setSelectedHealthOptions(
      current.focus_categories?.["Health Supplements"] || []
    );
    setSelectedBeautyOptions(current.focus_categories?.["Beauty & Skin"] || []);
    setSelectedFoodBeverage(
      current.focus_categories?.["Functional Food & Beverages"] || []
    );
    setSelectedPetNutrition(current.focus_categories?.["Pet Nutrition"] || []);
    setSelectedChannelCoverage(current.channel_coverage || []);
    setSelectedKeyCapabilities(current.service_capabilities || []);
    setSelectedWarehousing(current.warehousing || []);
    setSelectedBusinessModels(current.engagement_model?.[0] || "");
    setSelectedTradingTerms(current.trading_terms || "");
    setSelectedMinTenure(current.minimum_tenure || ""); // 🔥 Add this line
    setSelectedMarketingInvestment(current.trade_marketing_investments || "");
    setSelectedPaymentTerms(current.payment_terms?.[0] || "");
  }, [selectedMarket?.name]);

  useEffect(() => {
    if (!selectedMarket?.name) return;

    const updatedMarketData = {
      focus_categories: {
        "Health Supplements": getCategoryWithOther(
          selectedHealthOptions,
          otherValues?.[selectedMarket.name]?.["Health Supplements"]
        ),
        "Beauty & Skin": getCategoryWithOther(
          selectedBeautyOptions,
          otherValues?.[selectedMarket.name]?.["Beauty & Skin"]
        ),
        "Functional Food & Beverages": getCategoryWithOther(
          selectedFoodBeverage,
          otherValues?.[selectedMarket.name]?.["Functional Food & Beverages"]
        ),
        "Pet Nutrition": getCategoryWithOther(
          selectedPetNutrition,
          otherValues?.[selectedMarket.name]?.["Pet Nutrition"]
        ),
      },
      region: selectedMarket.id,
      channel_coverage: selectedChannelCoverage,
      service_capabilities: selectedKeyCapabilities,
      warehousing: selectedWarehousing,
      engagement_model: [selectedBusinessModels],
      trading_terms: selectedTradingTerms,
      minimum_tenure: selectedMinTenure,
      trade_marketing_investments: selectedMarketingInvestment,
      payment_terms: [selectedPaymentTerms],
    };

    setPartnerDetails((prev: any) => {
      const updated = {
        ...prev,
        markets: {
          ...(prev.markets || {}),
          [selectedMarket.name]: updatedMarketData,
        },
      };
      return updated;
    });
  }, [
    selectedHealthOptions,
    selectedBeautyOptions,
    selectedFoodBeverage,
    selectedPetNutrition,
    selectedChannelCoverage,
    selectedKeyCapabilities,
    selectedWarehousing,
    selectedBusinessModels,
    selectedTradingTerms,
    selectedMinTenure,
    selectedMarketingInvestment,
    selectedPaymentTerms,
    selectedMarket,
    otherValues,
  ]);

  useEffect(() => {
    if (!partnerDetails?.marketSelection?.length || !partnerDetails?.markets)
      return;

    const newProgressMap: Record<string, number> = {};

    partnerDetails.marketSelection.forEach((market: any) => {
      const data = partnerDetails.markets[market.name];
      if (!data) return;

      let count = 0;

      const focusCategoryValid =
        (data.focus_categories?.["Health Supplements"]?.length || 0) +
        (data.focus_categories?.["Beauty & Skin"]?.length || 0) +
        (data.focus_categories?.["Functional Food & Beverages"]?.length || 0) +
        (data.focus_categories?.["Pet Nutrition"]?.length || 0);

      if (focusCategoryValid > 0) count++;
      if (data.engagement_model?.[0]) count++;
      if (data.channel_coverage?.length) count++;
      if (data.minimum_tenure) count++;
      if (data.trading_terms) count++;
      if (data.payment_terms?.[0]) count++;
      if (data.trade_marketing_investments) count++;
      // if (data.service_capabilities?.length) {
      //   if (data.service_capabilities.includes("Warehousing")) {
      //     if (data.warehousing?.length) count++;
      //   } else {
      //     count++;
      //   }
      // }
      if (data.service_capabilities?.length) count++;

      newProgressMap[market.name] = count;
    });

    setMarketProgressMap(newProgressMap);
  }, [partnerDetails]);

  useEffect(() => {
    GetRegionsList()
      .then((res: any) => {
        setMarketList(res?.data);
      })
      .catch((err: any) => {
        console.error("Something went wrong:", err);
      });
  }, []);

  useEffect(() => {
    if (!editPartnerData?.market?.length || !marketList.length) return;

    const newMarketsObj: any = {};
    const selectedMarkets: any[] = [];
    const updatedOtherValues: any = {};

    editPartnerData.market.forEach((marketEntry: any) => {
      const regionMatch: any = marketList.find(
        (m: any) => m.id === marketEntry.region
      );
      if (!regionMatch) return;

      // Only include if it's still selected
      const isStillSelected = partnerDetails.marketSelection?.some(
        (m: any) => m.id === regionMatch.id
      );
      if (!isStillSelected) return;

      selectedMarkets.push(regionMatch);

      const focusCategoriesFromApi: any = {
        "Health Supplements": [],
        "Beauty & Skin": [],
        "Functional Food & Beverages": [],
        "Pet Nutrition": [],
      };

      marketEntry.categories?.forEach((cat: any) => {
        const categoryName = cat.focus_category;
        const subCategories = cat.sub_categories || [];

        if (
          categoryName &&
          focusCategoriesFromApi.hasOwnProperty(categoryName)
        ) {
          const options =
            categoryName === "Health Supplements"
              ? healthOptions
              : categoryName === "Beauty & Skin"
              ? beautyOptions
              : categoryName === "Functional Food & Beverages"
              ? functionalFoodBeveragesOptions
              : categoryName === "Pet Nutrition"
              ? petNutritionOptions
              : [];

          const customValue = subCategories.find(
            (item: string) => !options.includes(item)
          );

          if (customValue) {
            focusCategoriesFromApi[categoryName] = [
              "Other",
              ...subCategories.filter((s: string) => s !== customValue),
            ];
            updatedOtherValues[regionMatch.name] = {
              ...(updatedOtherValues[regionMatch.name] || {}),
              [categoryName]: customValue,
            };
          } else {
            focusCategoriesFromApi[categoryName] = subCategories;
          }
        }
      });

      newMarketsObj[regionMatch.name] = {
        focus_categories: focusCategoriesFromApi,
        region: regionMatch.id,
        channel_coverage: marketEntry.channel_coverage || [],
        service_capabilities: marketEntry.service_capabilities || [],
        warehousing: marketEntry.warehousing || [],
        engagement_model: marketEntry.engagement_model || [],
        trading_terms: marketEntry.trading_terms || "",
        minimum_tenure: marketEntry.minimum_tenure || "",
        trade_marketing_investments:
          marketEntry.trade_marketing_investments || "",
        payment_terms: marketEntry.payment_terms || [],
      };
    });

    setPartnerDetails((prev: any) => {
      const mergedMarkets = {
        ...(prev.markets || {}),
        ...newMarketsObj,
      };

      const existingIds = new Set(
        (prev.marketSelection || []).map((m: any) => m.id)
      );
      const mergedSelection = [
        ...(prev.marketSelection || []),
        ...selectedMarkets.filter((m: any) => !existingIds.has(m.id)),
      ];

      return {
        ...prev,
        markets: mergedMarkets,
        marketSelection: mergedSelection,
      };
    });

    setOtherValues((prev: any) => ({
      ...prev,
      ...updatedOtherValues,
    }));

    if (selectedMarkets.length) {
      const selected = selectedMarkets[0];
      const data = newMarketsObj[selected.name];

      setSelectedMarket(selected);
      setSelectedHealthOptions(
        data.focus_categories["Health Supplements"] || []
      );
      setSelectedBeautyOptions(data.focus_categories["Beauty & Skin"] || []);
      setSelectedFoodBeverage(
        data.focus_categories["Functional Food & Beverages"] || []
      );
      setSelectedPetNutrition(data.focus_categories["Pet Nutrition"] || []);
      setSelectedChannelCoverage(data.channel_coverage || []);
      setSelectedKeyCapabilities(data.service_capabilities || []);
      setSelectedWarehousing(data.warehousing || []);
      setSelectedBusinessModels(data.engagement_model?.[0] || "");
      setSelectedTradingTerms(data.trading_terms || "");
      setSelectedMinTenure(data.minimum_tenure || "");
      setSelectedMarketingInvestment(data.trade_marketing_investments || "");
      setSelectedPaymentTerms(data.payment_terms?.[0] || "");
    }
  }, [editPartnerData, marketList]);

  useEffect(() => {
    refHealthOptions.current = selectedHealthOptions;
    refBeautyOptions.current = selectedBeautyOptions;
    refFoodOptions.current = selectedFoodBeverage;
    refPetOptions.current = selectedPetNutrition;
    refChannel.current = selectedChannelCoverage;
    refCapabilities.current = selectedKeyCapabilities;
    refWarehousing.current = selectedWarehousing;
    refModel.current = selectedBusinessModels;
    refTerms.current = selectedTradingTerms;
    refTenure.current = selectedMinTenure;
    refMarketing.current = selectedMarketingInvestment;
    refPayment.current = selectedPaymentTerms;
  }, [
    selectedHealthOptions,
    selectedBeautyOptions,
    selectedFoodBeverage,
    selectedPetNutrition,
    selectedChannelCoverage,
    selectedKeyCapabilities,
    selectedWarehousing,
    selectedBusinessModels,
    selectedTradingTerms,
    selectedMinTenure,
    selectedMarketingInvestment,
    selectedPaymentTerms,
  ]);

  const setOtherValue = (category: string, value: string) => {
    setOtherValues((prev: any) => ({
      ...prev,
      [selectedMarket.name]: {
        ...(prev[selectedMarket.name] || {}),
        [category]: value,
      },
    }));
  };

  const getOtherValue = (category: string) =>
    otherValues?.[selectedMarket.name]?.[category] || "";

  const saveCurrentMarketData = () => {
    if (!selectedMarket?.name) return;

    const newMarketData = {
      focus_categories: {
        "Health Supplements": resolveOther(
          refHealthOptions.current,
          "Health Supplements"
        ),
        "Beauty & Skin": resolveOther(
          refBeautyOptions.current,
          "Beauty & Skin"
        ),
        "Functional Food & Beverages": resolveOther(
          refFoodOptions.current,
          "Functional Food & Beverages"
        ),
        "Pet Nutrition": resolveOther(refPetOptions.current, "Pet Nutrition"),
      },
      region: selectedMarket.id,
      channel_coverage: refChannel.current,
      service_capabilities: refCapabilities.current,
      warehousing: refWarehousing.current,
      engagement_model: [refModel.current],
      trading_terms: refTerms.current,
      minimum_tenure: refTenure.current,
      trade_marketing_investments: refMarketing.current,
      payment_terms: [refPayment.current],
    };

    setPartnerDetails((prev: any) => ({
      ...prev,
      markets: {
        ...(prev.markets || {}),
        [selectedMarket.name]: newMarketData,
      },
    }));
  };

  const selectMarket = (market: any) => {
    saveCurrentMarketData();

    setSelectedMarket(market);

    const current = partnerDetails?.markets?.[market.name] || {
      focus_categories: {
        "Health Supplements": [],
        "Beauty & Skin": [],
        "Functional Food & Beverages": [],
        "Pet Nutrition": [],
      },
      region: market.id,
      channel_coverage: [],
      service_capabilities: [],
      warehousing: [],
      engagement_model: [""],
      trading_terms: "",
      minimum_tenure: "",
      trade_marketing_investments: "",
      payment_terms: [""],
    };

    setSelectedHealthOptions(
      current.focus_categories["Health Supplements"] || []
    );
    setSelectedBeautyOptions(current.focus_categories["Beauty & Skin"] || []);
    setSelectedFoodBeverage(
      current.focus_categories["Functional Food & Beverages"] || []
    );
    setSelectedPetNutrition(current.focus_categories["Pet Nutrition"] || []);
    setSelectedChannelCoverage(current.channel_coverage || []);
    setSelectedKeyCapabilities(current.service_capabilities || []);
    setSelectedWarehousing(current.warehousing || []);
    setSelectedBusinessModels(current.engagement_model?.[0] || "");
    setSelectedTradingTerms(current.trading_terms || "");
    setSelectedMinTenure(current.minimum_tenure || "");
    setSelectedMarketingInvestment(current.trade_marketing_investments || "");
    setSelectedPaymentTerms(current.payment_terms?.[0] || "");
  };

  const availableMarkets = marketList.filter(
    (market: any) =>
      !partnerDetails.marketSelection?.some(
        (selected: any) => selected.id === market.id
      )
  );

  const handleSaveMarket = (values: any) => {
    const selectedIds = values.market;
    const newMarkets = marketList.filter((market: any) =>
      selectedIds.includes(market.id)
    );

    setPartnerDetails((prev: any) => {
      const existingMarkets = prev?.marketSelection || [];
      const existingMarketIds = existingMarkets.map((m: any) => m.id);

      const newSelections = newMarkets.filter(
        (m: any) => !existingMarketIds.includes(m.id)
      );

      return {
        ...prev,
        marketSelection: [...existingMarkets, ...newSelections],
      };
    });

    setOpenAddNewMarketModal(false);
  };

  const updateMarketData = (key: string, value: any) => {
    setPartnerDetails((prev: any) => {
      const updatedMarket = {
        ...(prev.markets?.[selectedMarket.name] || {}),
        [key]: value,
      };
      return {
        ...prev,
        markets: {
          ...prev.markets,
          [selectedMarket.name]: updatedMarket,
        },
      };
    });
  };

  const toggleFocusCategoryOption = (
    categoryKey: string,
    selected: string[],
    setSelected: (value: string[]) => void,
    option: string
  ) => {
    const updatedOptions = selected.includes(option)
      ? selected.filter((item) => item !== option)
      : [...selected, option];

    setSelected(updatedOptions);

    const existing =
      partnerDetails?.markets?.[selectedMarket.name]?.focus_categories || {};
    updateMarketData("focus_categories", {
      ...existing,
      [categoryKey]: updatedOptions,
    });
  };

  // Health
  const toggleHealthOption = (option: string) =>
    toggleFocusCategoryOption(
      "Health Supplements",
      selectedHealthOptions,
      setSelectedHealthOptions,
      option
    );

  // Beauty
  const toggleBeautyOption = (option: string) =>
    toggleFocusCategoryOption(
      "Beauty & Skin",
      selectedBeautyOptions,
      setSelectedBeautyOptions,
      option
    );

  // Food & Beverages
  const toggleFoodBeverageOption = (option: string) =>
    toggleFocusCategoryOption(
      "Functional Food & Beverages",
      selectedFoodBeverage,
      setSelectedFoodBeverage,
      option
    );

  // Pet Nutrition
  const togglePetNutritionOption = (option: string) =>
    toggleFocusCategoryOption(
      "Pet Nutrition",
      selectedPetNutrition,
      setSelectedPetNutrition,
      option
    );

  return (
    <div>
      <div className="flex items-center justify-between ">
        <p className="font-[600]  ">Service & Scope</p>
        <p
          className={`self-center m-[0] basis-[10%] self-end ${
            availableMarkets.length
              ? "text-[#667085] cursor-pointer"
              : "text-[#D0D0D0] cursor-not-allowed"
          }`}
          onClick={() => {
            if (availableMarkets.length) setOpenAddNewMarketModal(true);
          }}
        >
          Add New
        </p>
      </div>
      <div className="flex gap-[16px] border-b-[1px] border-[#E4E7EC] pb-[16px] ">
        <div className="flex gap-[16px] max-w-[650px] overflow-auto  ">
          {partnerDetails?.marketSelection.length ? (
            partnerDetails?.marketSelection.map((market: any) => (
              <div
                onClick={() => selectMarket(market)}
                style={{
                  background:
                    market?.id === selectedMarket?.id
                      ? "linear-gradient(98deg, #D5E3FF 0%, #FFF 100%)"
                      : "",
                }}
                className="min-w-[220px] cursor-pointer flex flex-col gap-[4px] p-[10px] border-[1px] border-[#E4E7EC] rounded-[6px] basis-[28%] "
              >
                <p className="m-[0]">{market?.name}</p>
                <div className="flex gap-[10px] ">
                  <Progress
                    percent={((marketProgressMap[market.name] || 0) / 8) * 100}
                    showInfo={false}
                  />
                  <p className="m-[0]">
                    {marketProgressMap[market.name] || 0}/08
                  </p>
                </div>
              </div>
            ))
          ) : (
            <></>
          )}
        </div>
      </div>
      <div className="flex pt-[40px] gap-[40px]">
        <div className=" h-fit">
          <Anchor
            replace
            affix={false}
            bounds={40}
            items={tabOptions}
            getContainer={() => containerRef.current || window}
          />
        </div>
        <div
          className="flex-1 max-h-[calc(100vh-200px)] overflow-y-auto pr-[16px]"
          ref={containerRef}
        >
          <div id="focus-category" className="mb-[40px]">
            <p className="text-[#1D2939] font-[500] p-[4px_10px] bg-[#F2F4F7] rounded-[4px] mb-[20px]">
              Focus Category
            </p>
            <Form form={serviceScopeForm} layout="vertical">
              <div className="flex flex-col gap-[40px]">
                <Form.Item
                  name="healthSupplements"
                  rules={[
                    {
                      required: true,
                      message: "Please select at least one Value Added Service",
                    },
                  ]}
                >
                  <MultiSelectCheckboxGroup
                    label="Health Supplements"
                    options={healthOptions}
                    selected={selectedHealthOptions}
                    setSelected={setSelectedHealthOptions}
                    checked={healthChecked}
                    setChecked={setHealthChecked}
                    // otherInputValue={healthOtherValue}
                    // setOtherInputValue={setHealthOtherValue}
                    otherInputValue={getOtherValue("Health Supplements")}
                    setOtherInputValue={(value) =>
                      setOtherValue("Health Supplements", value)
                    }
                    toggleSelection={toggleHealthOption}
                  />
                </Form.Item>
                <Form.Item
                  name="beautySkin"
                  rules={[
                    {
                      required: true,
                      message: "Please select at least one Value Added Service",
                    },
                  ]}
                >
                  <MultiSelectCheckboxGroup
                    label="Beauty & Skin"
                    options={beautyOptions}
                    selected={selectedBeautyOptions}
                    setSelected={setSelectedBeautyOptions}
                    checked={beautyChecked}
                    setChecked={setBeautyChecked}
                    // otherInputValue={beautyOtherValue}
                    // setOtherInputValue={setBeautyOtherValue}
                    otherInputValue={getOtherValue("Beauty & Skin")}
                    setOtherInputValue={(value) =>
                      setOtherValue("Beauty & Skin", value)
                    }
                    toggleSelection={toggleBeautyOption}
                  />
                </Form.Item>

                <Form.Item
                  name="functionalFoodBeverages"
                  rules={[
                    {
                      required: true,
                      message: "Please select at least one Value Added Service",
                    },
                  ]}
                >
                  <MultiSelectCheckboxGroup
                    label="Functional Food & Beverages"
                    options={functionalFoodBeveragesOptions}
                    selected={selectedFoodBeverage}
                    setSelected={setSelectedFoodBeverage}
                    checked={foodBeverageChecked}
                    setChecked={setFoodBeverageChecked}
                    // otherInputValue={foodBeverageOtherValue}
                    // setOtherInputValue={setFoodBeverageOtherValue}
                    otherInputValue={getOtherValue(
                      "Functional Food & Beverages"
                    )}
                    setOtherInputValue={(value) =>
                      setOtherValue("Functional Food & Beverages", value)
                    }
                    toggleSelection={toggleFoodBeverageOption}
                  />
                </Form.Item>
                <Form.Item
                  name="petNutrition"
                  rules={[
                    {
                      required: true,
                      message: "Please select at least one Value Added Service",
                    },
                  ]}
                >
                  <MultiSelectCheckboxGroup
                    label="Pet Nutrition"
                    options={petNutritionOptions}
                    selected={selectedPetNutrition}
                    setSelected={setSelectedPetNutrition}
                    checked={petNutritionChecked}
                    setChecked={setPetNutritionChecked}
                    // otherInputValue={petNutritionOtherValue}
                    // setOtherInputValue={setPetNutritionOtherValue}
                    otherInputValue={getOtherValue("Pet Nutrition")}
                    setOtherInputValue={(value) =>
                      setOtherValue("Pet Nutrition", value)
                    }
                    toggleSelection={togglePetNutritionOption}
                  />
                </Form.Item>
              </div>
            </Form>
          </div>

          <div id="channel-and-capabilities" className="mb-[40px] ">
            <p className="text-[#1D2939] font-[500] p-[4px_10px] bg-[#F2F4F7] rounded-[4px] mb-[20px]">
              Channel & Capabilities
            </p>
            <div className="flex flex-col gap-[40px]">
              <MultiSelectCheckboxGroup
                label="Key Channel Coverage"
                options={channelOptions}
                selected={selectedChannelCoverage}
                setSelected={setSelectedChannelCoverage}
                checked={channelChecked}
                setChecked={setChannelChecked}
                otherInputValue={channelOtherValue}
                setOtherInputValue={setChannelOtherValue}
                toggleSelection={(option: string) => {
                  if (selectedChannelCoverage.includes(option)) {
                    setSelectedChannelCoverage(
                      selectedChannelCoverage.filter(
                        (item: any) => item !== option
                      )
                    );
                  } else {
                    setSelectedChannelCoverage([
                      ...selectedChannelCoverage,
                      option,
                    ]);
                  }
                }}
              />
            </div>
            <div className="flex flex-col gap-[40px]">
              <MultiSelectCheckboxGroup
                label="Key Capabilities"
                options={keyCapabilitiesOptions}
                selected={selectedKeyCapabilities}
                setSelected={setSelectedKeyCapabilities}
                checked={keyCapabilitiesChecked}
                setChecked={setKeyCapabilitiesChecked}
                otherInputValue={keyCapabilitiesOtherValue}
                setOtherInputValue={setKeyCapabilitiesOtherValue}
                toggleSelection={(option: string) => {
                  if (selectedKeyCapabilities.includes(option)) {
                    setSelectedKeyCapabilities(
                      selectedKeyCapabilities.filter(
                        (item: any) => item !== option
                      )
                    );
                  } else {
                    setSelectedKeyCapabilities([
                      ...selectedKeyCapabilities,
                      option,
                    ]);
                  }
                }}
              />
            </div>
            {selectedKeyCapabilities.includes("Warehousing") && (
              <div className="flex flex-col gap-[40px]">
                <MultiSelectCheckboxGroup
                  label="Warehousing"
                  options={warehousingOptions}
                  selected={selectedWarehousing}
                  setSelected={setSelectedWarehousing}
                  checked={warehousingChecked}
                  setChecked={setWarehousingChecked}
                  otherInputValue={warehousingOtherValue}
                  setOtherInputValue={setWarehousingOtherValue}
                  toggleSelection={(option: string) => {
                    if (selectedWarehousing.includes(option)) {
                      setSelectedWarehousing(
                        selectedWarehousing.filter(
                          (item: any) => item !== option
                        )
                      );
                    } else {
                      setSelectedWarehousing([...selectedWarehousing, option]);
                    }
                  }}
                />
              </div>
            )}
          </div>

          <div id="engagement-terms" className="mb-[40px] ">
            <p className="text-[#1D2939] font-[500] p-[4px_10px] bg-[#F2F4F7] rounded-[4px] mb-[20px]">
              Engagement Terms
            </p>
            <div className="flex flex-col gap-[40px]">
              <Form.Item
                name="acceptedBusinessModels"
                rules={[
                  {
                    required: true,
                    message: "Please select the value",
                  },
                ]}
              >
                <SingleSelectButtonGroup
                  label="Accepted Business Models"
                  options={["Pre-Purchase", "Consignment", "Both"]}
                  selected={selectedBusinessModels}
                  setSelected={setSelectedBusinessModels}
                  checked={businessModelsChecked}
                  setChecked={setBusinessModelsChecked}
                />
              </Form.Item>
            </div>
            <div className="flex flex-col gap-[40px]">
              <Form.Item
                name="tradingTerms"
                rules={[
                  {
                    required: true,
                    message: "Please select the value",
                  },
                ]}
              >
                <SingleSelectButtonGroup
                  label="Trading Terms"
                  options={["Exclusive", "Non - Exclusive", "Both"]}
                  selected={selectedTradingTerms}
                  setSelected={setSelectedTradingTerms}
                  checked={tradingTermsChecked}
                  setChecked={setTradingTermsChecked}
                />
              </Form.Item>
            </div>
            <div className="flex flex-col gap-[40px]">
              <Form.Item
                name="minimumExclusivityTenure"
                rules={[
                  {
                    required: true,
                    message: "Please select the value",
                  },
                ]}
              >
                <SingleSelectButtonGroup
                  label="Minimum Exclusivity Tenure"
                  options={["3 yrs or more", "2 yrs", "1 yr"]}
                  selected={selectedMinTenure}
                  setSelected={setSelectedMinTenure}
                  checked={minTenureChecked}
                  setChecked={setMinTenureChecked}
                />
              </Form.Item>
            </div>
            <div className="flex flex-col gap-[40px]">
              <Form.Item
                name="preferenceMarketingInvestment"
                rules={[
                  {
                    required: true,
                    message: "Please select the value",
                  },
                ]}
              >
                <SingleSelectButtonGroup
                  label="Preference on Marketing Investment"
                  options={[
                    "Partner Responsibility",
                    "Brand Responsibility",
                    "Co - Responsibility",
                  ]}
                  selected={selectedMarketingInvestment}
                  setSelected={setSelectedMarketingInvestment}
                  checked={marketingInvestmentChecked}
                  setChecked={setMarketingInvestmentChecked}
                />
              </Form.Item>
            </div>
            <div className="flex flex-col gap-[40px]">
              <Form.Item
                name="paymentTerms"
                rules={[
                  {
                    required: true,
                    message: "Please select the value",
                  },
                ]}
              >
                <SingleSelectButtonGroup
                  label="Payment Terms"
                  options={["Escrow", "COD", "Bank LC", "30-60 Days Credit"]}
                  selected={selectedPaymentTerms}
                  setSelected={setSelectedPaymentTerms}
                  checked={paymentTermsChecked}
                  setChecked={setPaymentTermsChecked}
                />
              </Form.Item>
            </div>
          </div>
        </div>
      </div>
      <AddNewMarketModal
        open={openAddNewMarketModal}
        onCancel={() => setOpenAddNewMarketModal(false)}
        onSubmit={handleSaveMarket}
        markets={availableMarkets}
      />
    </div>
  );
};

export default ServiceAndScope;
